import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NouisliderModule } from 'ng2-nouislider';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { RouterModule } from '@angular/router';

import { BasicelementsComponent } from './basicelements/basicelements.component';
import { NavigationComponent } from './navigation/navigation.component';
import { TypographyComponent } from './typography/typography.component';
import { ComponentsComponent } from './components.component';
import { NotificationComponent } from './notification/notification.component';
import { NgbdModalComponent } from './modal/modal.component';
import { NgbdModalContent } from './modal/modal.component';
import { ImagenesModalComponent } from './imagenes-modal/imagenes-modal.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PaquetesComponent } from './paquetes/paquetes.component';
import { PaqueteComponent } from './paquete/paquete.component';
import { AereoComponent } from './aereo/aereo.component';
import { TerminosycondicionesComponent } from './terminosycondiciones/terminosycondiciones.component';
import { GrupoComponent } from './grupo/grupo.component';
import { CotizacionComponent } from './cotizacion/cotizacion.component';
import { TarjetasComponent } from './tarjetas/tarjetas.component';
import { TransferenciaComponent } from './transferencia/transferencia.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NouisliderModule,
        RouterModule,
        JwBootstrapSwitchNg2Module,
        ReactiveFormsModule
    ],
    declarations: [
        ComponentsComponent,
        BasicelementsComponent,
        NavigationComponent,
        TypographyComponent,
        NotificationComponent,
        NgbdModalComponent,
        NgbdModalContent,
        ImagenesModalComponent,
        PaquetesComponent,
        PaqueteComponent,
        GrupoComponent,
        AereoComponent,
        TerminosycondicionesComponent,
        CotizacionComponent,
        TarjetasComponent,
        TransferenciaComponent
    ],
    entryComponents: [NgbdModalContent],
    exports:[ ComponentsComponent ]
})
export class ComponentsModule { }
